import styled from "styled-components";

export const ContainerReserve = styled.div`
  width: 90%;
  min-width: 290px;
  max-width: 400px;
  background-color: var(--secondary-color);
  border-radius: 5px;
  border-bottom-right-radius: 50px;
  color: var(--primary-color);
  display: flex;
  justify-content: space-evenly;
  padding: 0.5rem;
  margin: 0.5rem;
  margin-left: 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 25%;
`;
export const InfosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
`;

export const Date = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--details-color);
`;
export const Name = styled.p``;
